import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocale } from '@gov-nx/core/service';
import { useDataBoxUnreadMessages } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { useDataBoxStoreLists } from '@gov-nx/store';
import {
	Button,
	ButtonGroupLayout,
	Icon,
	LayoutGap,
	SectionHeader,
} from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';

export const HomepageImportantSection = () => {
	// const { unreadNotificationsCount } = useNotificationMessageLoader();
	const { unreadMessagesCount } = useDataBoxUnreadMessages();
	const { getHasConnectedDatabox } = useDataBoxStoreLists();
	const hasConnectedDatabox = getHasConnectedDatabox();
	const code = PageCode['rozcestnik'];
	const { t } = useLocale(code);
	const navigate = useNavigate();

	if (!hasConnectedDatabox) return null;

	return (
		<section aria-labelledby="neprehlednete">
			<LayoutGap gap="m">
				<SectionHeader
					id="neprehlednete"
					headline={t('nadpis.neprehlednete')}
				/>
				<ButtonGroupLayout align="left">
					<Button
						color="secondary"
						type="solid"
						size="m"
						isExpandedMobile
						onClick={() => navigate(pageRouteResolver('datove-schranky'))}
						iconStart={
							<Icon
								name="datovka-fill"
								type="templates"
							/>
						}
						iconEnd={
							<Icon
								name="chevron-right"
								type="components"
							/>
						}>
						{t('akce.neprectene-zpravy-pocet', {
							count: unreadMessagesCount,
						})}
					</Button>
					{/* 
					TODO: Uncomment when notifications are ready for PP
					<Button
						color="secondary"
						type="outlined"
						size="m"
						isExpandedMobile
						iconStart={
							<Icon
								name="bell-fill"
								type="templates"
							/>
						}
						iconEnd={
							<Icon
								name="chevron-right"
								type="components"
							/>
						}
						onClick={() => navigate(pageRouteResolver('upozorneni'))}>
						{t('akce.neprectene-notifikace-pocet', {
							count: unreadNotificationsCount,
						})}
					</Button> */}
				</ButtonGroupLayout>
			</LayoutGap>
		</section>
	);
};
